import {
  getActiveCanvas,
  isARCEnabled
} from '../../utilities/HelperFunctions/HelperFunctions';
import {
  setLoadingState,
  replacePlacing,
  setScenePlacingOffsetAndSize,
  getElementImagePath,
  addBackgroundElement,
  duplicateText,
  addPlacingToProject,
  addElement,
  addToUndoManager,
  toggleDirtyBit,
  setBoundsForElement,
  updateProjectPlacingsCoords,
  addElementWithPlacing,
  deleteCanavsElement,
  setBoundsAndOriginForElement,
  checkForElementsControls,
  selectObject,
  updatePlacingCoords,
  getMinXPointOfObject,
  getMaxXPointOfObject,
  getMaxYPointOfObject,
  getMinYPointOfObject,
  setPositionForElement,
  sceneBoundaryPoints,
  redrawCanvas
} from '../fabricCanvasActions';
import {
  DEFAULT_TILED_SCALE,
  LAYER_ID_BACKGROUND,
  MINIMUM_ZOOM_VALUE,
  PROJECT_KEY,
  SLIDER_MAX_VALUE,
  SLIDER_MIN_VALUE,
  TEXT_ELEMENT_TYPE,
  MAXIMUM_ZOOM_VALUE
} from '../../utilities/constants/Constants';
import { fabric } from 'fabric';
import {
  backgroundElement,
  canvasElementsExceptBackground,
  createText,
  getScaleToFillCanvasFactorForElement,
  getScaleToFillCanvasFactorForScene,
  isBackground,
  isImageBasedBackground,
  isWallLayout
} from '../fabricCanvasActionHelpers';
import { objectIsSelected } from '../sideBarActions';
import actionTypes from '../actionTypes';
import { string } from '../../localization';
import { checkObjectForPixelation } from './pixelationHandler';
import { generatePreviewOfStickers } from './stickerActions';
import { generatePreviewsOfSideWalls, isSharedScene } from './multiWallHandler';

export const tileAction = (element, canvas) => (dispatch, getState) => {
  let defaultSacleSliderValue = 0;
  const { partnerStoreType } = getState().modal.storeData;
  const { category } = getState().modal.envData;
  if (!isARCEnabled(category, partnerStoreType)) {
    defaultSacleSliderValue = DEFAULT_TILED_SCALE;
  }
  element.scaleSliderValue = defaultSacleSliderValue;
  dispatch(tileScene(element, canvas, null));
};

export const tileScene = (element, canvas, completion) => (
  dispatch,
  getState
) => {
  dispatch(setLoadingState(''));

  const { projectWidth, projectHeight } = getState().home;
  let tileDimensionObj;
  let sliderValue = Object.prototype.hasOwnProperty.call(
    element,
    'scaleSliderValue'
  )
    ? element.scaleSliderValue
    : 0;
  const scaleFactor = dispatch(getScaleToFillCanvasFactorForScene(element));
  let tileRectWidth = element.width * scaleFactor;
  let tileRectHeight = element.height * scaleFactor;

  const tileDimension = dispatch(getDefaultTileSize(element));
  const tileWidth = tileDimension.width;
  const tileHeight = tileDimension.height;

  const { partnerStoreType } = getState().modal.storeData;
  const projectCategory = getState().modal.envData.category;
  if (isARCEnabled(projectCategory, partnerStoreType)) {
    tileRectWidth = canvas.width;
    const wallScale = projectHeight / canvas.height;
    const tileCount = Number(projectHeight / tileHeight);
    const singleTileViewSize = tileHeight / wallScale;
    const visibleTilePart = canvas.height - singleTileViewSize * tileCount;
    const hiddenTilePart = singleTileViewSize - visibleTilePart;
    tileRectHeight = canvas.height + hiddenTilePart;
  }

  if (!Object.prototype.hasOwnProperty.call(element, 'tiledDimensions')) {
    tileDimensionObj = {
      width: tileWidth,
      height: tileHeight,
      scale: 1
    };
    if (sliderValue) {
      const extendedBufferSize = 0;
      const value = Math.max(
        (projectWidth + extendedBufferSize) / tileWidth,
        (projectHeight + extendedBufferSize) / tileHeight
      );

      const maximumTileScale =
        SLIDER_MAX_VALUE / Math.max(tileWidth, tileHeight);
      const maximumZoom = Math.min(maximumTileScale, value);
      const sliderCalculatedValue =
        MINIMUM_ZOOM_VALUE +
        (sliderValue * (maximumZoom - SLIDER_MIN_VALUE)) / SLIDER_MAX_VALUE;
      tileDimensionObj.scale = sliderCalculatedValue;
    }
  } else {
    tileDimensionObj = element.tiledDimensions;
    const scaleValue = tileDimensionObj.scale;
    const extendedBufferSize = 0;
    const value = Math.max(
      (projectWidth + extendedBufferSize) / tileWidth,
      (projectHeight + extendedBufferSize) / tileHeight
    );
    const maximumTileScale = SLIDER_MAX_VALUE / Math.max(tileWidth, tileHeight);
    const maximumZoom = Math.min(maximumTileScale, value);
    sliderValue =
      ((scaleValue - MINIMUM_ZOOM_VALUE) * SLIDER_MAX_VALUE) /
      (maximumZoom - SLIDER_MIN_VALUE);
    sliderValue = sliderValue.toFixed(2);
  }

  const newPlaing = { ...element.placing };
  newPlaing.tiled = true;
  dispatch(replacePlacing(element.placing, newPlaing));

  const rect = new fabric.Rect({
    height: tileRectHeight,
    width: tileRectWidth,
    strokeWidth: 0,
    fill: 'rgba(166, 166, 166)',
    placing: newPlaing,
    unTileObject: element,
    tiledDimensions: tileDimensionObj,
    layer: LAYER_ID_BACKGROUND
  });
  rect.scaleSliderValue = sliderValue;
  rect.hasControls = false;
  rect.hasBorders = false;

  const tileSize = {
    width: tileWidth,
    height: tileHeight
  };

  dispatch(
    drawTiledImages(
      element,
      rect,
      tileSize,
      tileDimensionObj.scale,
      canvas,
      completion
    )
  );
};

export const getDefaultTileSize = imageObj => (dispatch, getState) => {
  const minimumTileDimension = 10;
  const { wallCanvas } = getState().fabricCanvas;
  const projectScale = getState().home.projectHeight / wallCanvas.height;
  let tileDimension;
  let tileWidth;
  let tileHeight;

  const { partnerStoreType } = getState().modal.storeData;
  const projectCategory = getState().modal.envData.category;
  if (isARCEnabled(projectCategory, partnerStoreType)) {
    const placeableRatio = imageObj.width / imageObj.height;
    tileWidth = getState().home.projectWidth;
    tileHeight = tileWidth / placeableRatio;
  } else {
    if (getState().home.projectWidth < getState().home.projectHeight) {
      tileDimension =
        (getState().home.projectWidth * minimumTileDimension) / 144;
    } else {
      tileDimension =
        (getState().home.projectHeight * minimumTileDimension) / 96;
    }
    if (tileDimension < 1) {
      tileDimension = 1;
    }

    const placeableRatio = imageObj.width / imageObj.height;
    if (imageObj.width * projectScale >= imageObj.height * projectScale) {
      tileHeight = tileDimension;
      tileWidth = tileHeight * placeableRatio;
    } else {
      tileWidth = tileDimension;
      tileHeight = tileWidth / placeableRatio;
    }
  }
  return { width: tileWidth, height: tileHeight };
};

// This way was tiling absolutely good. But there was issue related to x and y position. Bcz tileRect was
// Filled with pattern and pattern was scaling wrt center not origin.

/* export const drawTiledImages = (
  element,
  tileRect,
  tileSize,
  scaleValue,
  canvas,
  callback
) => (dispatch, getState) => {
  const { projectHeight } = getState().home;
  const wallScale = projectHeight / getState().fabricCanvas.canvas.height;

  if (tileRect.patternObj) {
    const offscreenCanvasTileWidth = (tileSize.width / wallScale) * scaleValue;
    const offscreenCanvasTileHeight =
      (tileSize.height / wallScale) * scaleValue;

    let newScaleValue = 1;
    if (offscreenCanvasTileHeight > offscreenCanvasTileWidth) {
      newScaleValue =
        offscreenCanvasTileHeight / tileRect.offscreenCanvasSize.height;
    } else {
      newScaleValue =
        offscreenCanvasTileWidth / tileRect.offscreenCanvasSize.width;
    }
    let matrix = new DOMMatrix();
    matrix = matrix.translate(
      -tileRect.offscreenCanvasSize.width,
      -tileRect.offscreenCanvasSize.height
    );
    matrix = matrix.scale(newScaleValue);
    matrix = matrix.translate(
      tileRect.offscreenCanvasSize.width,
      tileRect.offscreenCanvasSize.height
    );
    tileRect.patternObj.setTransform(matrix);
    tileRect.set({
      fill: tileRect.patternObj,
      objectCaching: false,
      patternObj: tileRect.patternObj,
      offscreenCanvasSize: {
        width: tileRect.offscreenCanvasSize.width,
        height: tileRect.offscreenCanvasSize.height
      }
    });
  } else {
    const newPath = dispatch(getElementImagePath(element.placing));

    const newImage = new Image();
    newImage.src = newPath;
    newImage.onload = () => {
      const offscreenCanvas = document.createElement('canvas');
      offscreenCanvas.width = newImage.width;
      offscreenCanvas.height = newImage.height;
      const offscreenContext = offscreenCanvas.getContext('2d');

      offscreenContext.drawImage(
        newImage,
        0,
        0,
        newImage.width,
        newImage.height
      );

      const pattern = offscreenContext.createPattern(offscreenCanvas, 'repeat');
      const offscreenCanvasTileWidth =
        (tileSize.width / wallScale) * scaleValue;
      const offscreenCanvasTileHeight =
        (tileSize.height / wallScale) * scaleValue;

      let newScaleValue = 1;
      if (offscreenCanvasTileHeight > offscreenCanvasTileWidth) {
        newScaleValue = offscreenCanvasTileHeight / offscreenCanvas.height;
      } else {
        newScaleValue = offscreenCanvasTileWidth / offscreenCanvas.width;
      }
      let matrix = new DOMMatrix();
      matrix = matrix.translate(
        -offscreenCanvas.width,
        -offscreenCanvas.height
      );

      matrix = matrix.scale(newScaleValue);
      matrix = matrix.translate(offscreenCanvas.width, offscreenCanvas.height);
      pattern.setTransform(matrix);

      tileRect.set({
        fill: pattern,
        objectCaching: false,
        patternObj: pattern,
        offscreenCanvasSize: {
          width: offscreenCanvas.width,
          height: offscreenCanvas.height
        }
      });
      dispatch(addBackgroundElement(tileRect, canvas));
      if (callback) {
        callback(tileRect);
      }
    };
  }
}; */

export const drawTiledImages = (
  element,
  tileRect,
  tileSize,
  scaleValue,
  canvas,
  callback
) => (dispatch, getState) => {
  const { projectHeight } = getState().home;
  const wallScale = projectHeight / canvas.height;

  // Patch: offscreen canvas width is double the width of which we set. Hence tile size is displayed twice. As a patch
  // Reducing the tile size by half.
  const reducedTileSize = {
    width: tileSize.width / 2,
    height: tileSize.height / 2
  };

  if (tileRect.patternImage) {
    const { patternImage, offscreenCanvas } = tileRect;
    scaleDownToTiledSize(
      reducedTileSize,
      wallScale,
      scaleValue,
      offscreenCanvas,
      patternImage
    );
  } else {
    const newPath = dispatch(getElementImagePath(element.placing));
    fabric.Image.fromURL(newPath, img => {
      img.set({
        flipX: element.placing.flipX
      });
      const offscreenCanvasWidth = img.width;
      const offscreenCanvasHeight = img.height;
      const offscreenCanvas = new fabric.StaticCanvas();
      offscreenCanvas.setDimensions({
        width: offscreenCanvasWidth,
        height: offscreenCanvasHeight
      });
      offscreenCanvas.add(img);
      offscreenCanvas.renderAll();
      const pattern = new fabric.Pattern({
        source: offscreenCanvas.getElement(),
        repeat: 'repeat'
      });
      tileRect.set({
        fill: pattern,
        objectCaching: false,
        patternImage: img,
        offscreenCanvas
      });
      scaleDownToTiledSize(
        reducedTileSize,
        wallScale,
        scaleValue,
        offscreenCanvas,
        img
      );
      canvas.viewportCenterObject(tileRect);
      dispatch(addBackgroundElement(tileRect, canvas));
      if (callback) {
        callback(tileRect);
      }
    });
  }
};

export const scaleDownToTiledSize = (
  tileSize,
  wallScale,
  scaleSliderValue,
  offscreenCanvas,
  patternImage
) => {
  const offscreenCanvasTileWidth =
    (tileSize.width / wallScale) * scaleSliderValue;
  const offscreenCanvasTileHeight =
    (tileSize.height / wallScale) * scaleSliderValue;

  offscreenCanvas.setDimensions({
    width: offscreenCanvasTileWidth,
    height: offscreenCanvasTileHeight
  });
  let newScaleValue = 1;
  if (offscreenCanvasTileHeight > offscreenCanvasTileWidth) {
    newScaleValue = offscreenCanvasTileHeight / patternImage.height;
  } else {
    newScaleValue = offscreenCanvasTileWidth / patternImage.width;
  }
  patternImage.scale(newScaleValue).setCoords();
  offscreenCanvas.renderAll();
};

export const addTileBackground = (element, canvas, callback) => dispatch => {
  canvas.add(element);
  dispatch(tileScene(element, canvas, callback));
  canvas.remove(element);
};

export const unTileAction = (canvasTiledScene, canvas) => (
  dispatch,
  getState
) => {
  if (
    Object.prototype.hasOwnProperty.call(canvasTiledScene, 'unTileObject') &&
    canvasTiledScene.unTileObject
  ) {
    dispatch(setLoadingState(''));
    const { placing } = canvasTiledScene.unTileObject;
    dispatch(replacePlacing(canvasTiledScene.placing, placing));
    placing.tiled = false;
    dispatch(setScenePlacingOffsetAndSize(placing));
    const newPath = dispatch(getElementImagePath(placing));

    fabric.Image.fromURL(newPath, unTiledElement => {
      unTiledElement.set({
        placing,
        flipX: placing.flipX,
        top: 0,
        left: 0,
        layer: LAYER_ID_BACKGROUND
      });

      const projectScale = getState().home.projectHeight / canvas.height;
      const totalScaleValue =
        placing.width / (unTiledElement.width * projectScale);
      unTiledElement.scale(totalScaleValue).setCoords();
      unTiledElement
        .set({
          left: placing.xOffset / projectScale,
          top: placing.yOffset / projectScale
        })
        .setCoords();
      unTiledElement.hasControls = false;
      unTiledElement.hasBorders = false;
      unTiledElement.scaleSliderValue = 0;
      dispatch(addBackgroundElement(unTiledElement, canvas));
    });
  }
};

export const canDuplicateElement = element =>
  !isBackground(element) && !isWallLayout(element);

export const duplicateAction = (element, canvas) => dispatch => {
  dispatch(setLoadingState(string.LOADING_KEY));
  if (canDuplicateElement(element)) {
    if (element.placing.placeableType === TEXT_ELEMENT_TYPE) {
      dispatch(duplicateText());
    } else {
      const duplicatedPlacing = JSON.parse(JSON.stringify(element.placing));
      if (duplicatedPlacing.zIndex) duplicatedPlacing.zIndex += 1;
      const object = fabric.util.object.clone(element);
      object.placing = duplicatedPlacing;
      if (Object.prototype.hasOwnProperty.call(element, 'layer')) {
        object.layer = element.layer;
      }
      object.set({
        top: object.top + 20,
        left: object.left + 20
      });
      object.placing.id = null;
      if (duplicatedPlacing.placeableType === TEXT_ELEMENT_TYPE) {
        duplicatedPlacing.placeableId = null;
        duplicatedPlacing.placeable.id = null;
        dispatch(
          createText(duplicatedPlacing, () => {
            dispatch(objectIsSelected(canvas.getActiveObject()));
          })
        );
      }
      dispatch(addPlacingToProject(duplicatedPlacing));
      dispatch(addElement(object, true));
      dispatch(setLoadingState(null));
      dispatch(
        addToUndoManager({
          undo() {
            canvas.remove(object);
            canvas.renderAll();
            dispatch(toggleDirtyBit());
          },
          redo() {
            canvas.add(object);
            object.set({
              top: object.top,
              left: object.left
            });
            canvas.discardActiveObject();
            canvas.setActiveObject(object);
            canvas.renderAll();
            dispatch(toggleDirtyBit());
          }
        })
      );
    }
  }
};

export const resizeArbitrarilyAction = (element, canvas) => dispatch => {
  element.setControlsVisibility({
    tl: true, //  top-left
    mt: true, //   middle-top
    tr: true, //  top-right
    ml: true, //  middle-left
    mr: true, //  middle-right
    bl: true, //   bottom-left
    mb: true, //  middle-bottom
    br: true, //  bottom-right
    mtr: false //  bottom-right
  });
  element.set({
    resizeType: 'arbitrarily'
  });
  dispatch({
    type: actionTypes.SET_ACTIVE_OBJECT,
    payload: {
      activeObject: element
    }
  });
  canvas.renderAll();
};

export const resizeProportionallyAction = (element, canvas) => dispatch => {
  element.setControlsVisibility({
    tl: true, //  top-left
    mt: false, //   middle-top
    tr: true, //  top-right
    ml: false, //  middle-left
    mr: false, //  middle-right
    bl: true, //   bottom-left
    mb: false, //  middle-bottom
    br: true, //  bottom-right
    mtr: true //  bottom-right
  });

  const prevScaleX = element.scaleX;
  const prevScaleY = element.scaleY;
  const prevLeft = element.left;
  const prevTop = element.top;
  const prevWidth = element.width;
  const prevHeight = element.height;
  const prevAngle = element.angle;

  const scale = element.scaleX;
  element.scale(scale).setCoords();
  element.set({
    resizeType: 'proportionally'
  });
  dispatch(
    addToUndoManager({
      undo: () => {
        dispatch(
          setBoundsForElement(
            element,
            canvas,
            prevLeft,
            prevTop,
            prevScaleX,
            prevScaleY,
            prevAngle,
            prevWidth,
            prevHeight
          )
        );
      },
      redo: () => {
        dispatch(
          setBoundsForElement(
            element,
            canvas,
            element.left,
            element.top,
            element.scaleX,
            element.scaleY,
            element.angle,
            element.width,
            element.height
          )
        );
      }
    })
  );

  dispatch({
    type: actionTypes.SET_ACTIVE_OBJECT,
    payload: {
      activeObject: element
    }
  });
  canvas.renderAll();
};

export const deleteAction = element => dispatch => {
  dispatch(updateProjectPlacingsCoords());
  dispatch(
    addToUndoManager({
      undo: () => {
        dispatch(addElementWithPlacing(element));
      },
      redo: () => {
        dispatch(deleteCanavsElement(element));
      }
    })
  );
  dispatch(deleteCanavsElement(element));
};

export const sendToBackAction = (element, canvas) => dispatch => {
  dispatch(handleSendToBack(element, canvas));
  dispatch(
    addToUndoManager({
      undo: () => {
        dispatch(handleBringToFront(element, canvas));
      },
      redo: () => {
        dispatch(handleSendToBack(element, canvas));
      }
    })
  );
};

export const bringToFrontAction = (element, canvas) => dispatch => {
  dispatch(handleBringToFront(element, canvas));
  dispatch(
    addToUndoManager({
      undo: () => {
        dispatch(handleSendToBack(element, canvas));
      },
      redo: () => {
        dispatch(handleBringToFront(element, canvas));
      }
    })
  );
};

export const handleSendToBack = (element, canvas) => dispatch => {
  const minZIndex = minimumZIndex(canvas);
  element.moveTo(minZIndex);
  canvas.renderAll();
  dispatch(toggleDirtyBit());
};

export const handleBringToFront = (element, canvas) => dispatch => {
  const canvasObjects = canvas.getObjects();
  element.moveTo(canvasObjects.length - 1);
  canvas.renderAll();
  dispatch(toggleDirtyBit());
};

export const minimumZIndex = canvas => {
  const allContents = canvas.getObjects();
  const elemnts = canvasElementsExceptBackground(canvas);
  return allContents.length - elemnts.length;
};

export const flipAction = (element, canvas) => dispatch => {
  dispatch(handleFlipXElement(element, canvas));

  dispatch(
    addToUndoManager({
      undo: () => {
        dispatch(handleFlipXElement(element, canvas));
      },
      redo: () => {
        dispatch(handleFlipXElement(element, canvas));
      }
    })
  );
};

export const handleFlipXElement = (element, canvas) => dispatch => {
  element.toggle('flipX');
  element.placing.flipX = element.flipX;
  canvas.renderAll();
  dispatch(toggleDirtyBit());
  dispatch(generatePreviewOfStickers());
  if (dispatch(isSharedScene())) {
    dispatch(generatePreviewsOfSideWalls());
  }
};

export const scaleToFillAction = (element, canvas) => dispatch => {
  const scale = dispatch(getScaleToFillCanvasFactorForElement(element, canvas));
  const prevScaleX = element.scaleX;
  const prevScaleY = element.scaleY;
  const prevLeft = element.left;
  const prevTop = element.top;
  const prevWidth = element.width;
  const prevHeight = element.height;
  const prevAngle = element.angle;
  const prevOriginX = element.originX;
  const prevOriginY = element.originY;

  if (prevScaleX != scale || prevScaleY != scale) {
    dispatch(
      addToUndoManager({
        undo: () => {
          dispatch(
            setBoundsAndOriginForElement(
              element,
              canvas,
              prevLeft,
              prevTop,
              prevScaleX,
              prevScaleY,
              prevAngle,
              prevWidth,
              prevHeight,
              prevOriginX,
              prevOriginY
            )
          );
        },

        redo: () => {
          dispatch(handleScaleToFill(element, canvas, scale));
        }
      })
    );
    dispatch(handleScaleToFill(element, canvas, scale));
  }
};

//  If this function is called else where, pls note scaleY is not used. Works only for scale To Fill and its undo
export const handleScaleToFill = (element, canvas, scaleX) => dispatch => {
  const oldAngle = element.angle;
  element.rotate(0);

  element.scale(scaleX);
  element.set({
    left: 0,
    top: 0
  });
  element.setCoords();

  element.rotate(oldAngle);
  element.setCoords();

  dispatch(checkObjectForPixelation(element));
  canvas.renderAll();
  dispatch(toggleDirtyBit());
};

export const groupAction = () => (dispatch, getState) => {
  const { undoInstance, wallCanvas } = getState().fabricCanvas;
  undoInstance.add({
    undo: () => {
      dispatch(updateGroupState(wallCanvas, false));
    },
    redo: () => {
      dispatch(updateGroupState(wallCanvas, true));
    }
  });
  dispatch(updateGroupState(wallCanvas, true));
};

export const ungroupAction = () => (dispatch, getState) => {
  const { undoInstance, wallCanvas } = getState().fabricCanvas;
  undoInstance.add({
    undo: () => {
      dispatch(updateGroupState(wallCanvas, true));
    },
    redo: () => {
      dispatch(updateGroupState(wallCanvas, false));
    }
  });
  dispatch(updateGroupState(wallCanvas, false));
};

export const updateGroupState = (canvas, groupState) => dispatch => {
  dispatch({
    type: actionTypes.SET_GROUP_PROPERTY,
    payload: {
      isGrouped: groupState
    }
  });
  dispatch(checkForElementsControls());
  dispatch(selectObject(backgroundElement(canvas)));
  canvas.renderAll();
  dispatch(toggleDirtyBit());
};

// Transparency

export const setElementTransparency = (
  opacity,
  element,
  canvas
) => dispatch => {
  dispatch(changeTransparency(element));
  dispatch(changeTransparencyOfElement(opacity, element, canvas));
};

export const changeTransparency = activeObject => (dispatch, getState) => {
  const canvas = dispatch(getActiveCanvas(activeObject.placing));
  const undoManager = getState().fabricCanvas.undoInstance;

  if (undoManager.getUndoEnableState() === true) {
    undoManager.beginGroup();

    const prevTransparency = 1 - activeObject.opacity;
    dispatch(
      addToUndoManager({
        undo: () => {
          dispatch(
            changeTransparencyOfElement(prevTransparency, activeObject, canvas)
          );
        },
        redo: () => {}
      })
    );
    undoManager.disableUndo();
  }
};

export const changeTransparencyOfElement = (
  opacity,
  element,
  canvas
) => dispatch => {
  const canvasOpacity = 1 - opacity;
  element.set({
    opacity: canvasOpacity
  });
  element.placing.opacity = canvasOpacity;
  dispatch({
    type: actionTypes.UPDATE_TRANSPARENCY_MODAL,
    payload: {
      value: parseFloat(opacity).toFixed(2)
    }
  });
  canvas.renderAll();
  dispatch(toggleDirtyBit());
};

export const endTransparency = activeObject => (dispatch, getState) => {
  const canvas = dispatch(getActiveCanvas(activeObject.placing));
  const undoManager = getState().fabricCanvas.undoInstance;
  if (undoManager.getUndoEnableState() === false) {
    undoManager.enableUndo();

    const transparency = 1 - activeObject.opacity;
    dispatch(
      addToUndoManager({
        undo: () => {},
        redo: () => {
          dispatch(
            changeTransparencyOfElement(transparency, activeObject, canvas)
          );
        }
      })
    );
    undoManager.endGroup();
  }
};

export const dragTransparencyModal = e => dispatch => {
  const transparency = 1 - e.opacity;
  dispatch({
    type: actionTypes.UPDATE_TRANSPARENCY_MODAL,
    payload: {
      value: transparency
    }
  });
};

// Rotation

export const rotateElement = (element, inAngle, canvas) => (
  dispatch,
  getState
) => {
  let angle;
  if (inAngle >= 0) {
    angle = inAngle % 360;
  } else {
    angle = (inAngle % 360) + 360;
  }
  //  Since fabric JS has clockwise rotation and ROR needs anticlcokwise rotation , converting to ROR angle and storing it in Redux
  const theAngle = angle ? 360 - angle : angle;
  const rotatedAngle = getState().fabricCanvas.rotateModalValue;
  const returnedTarget = Object.assign(Number(rotatedAngle)).valueOf();

  if (returnedTarget !== theAngle) {
    const prevAngle = 360 - element.angle;
    dispatch(handleRotation(element, theAngle, canvas));
    dispatch(
      addToUndoManager({
        undo: () => {
          dispatch(handleRotation(element, prevAngle, canvas));
        },
        redo: () => {
          dispatch(handleRotation(element, theAngle, canvas));
        }
      })
    );
  }
};

export const handleRotation = (element, angle, canvas) => dispatch => {
  //  Since fabric JS has clockwise rotation and ROR needs anticlcokwise rotation , converting ROR angle to fabric angle while applying
  const fabricAngle = angle ? 360 - angle : angle;

  const originalOriginX = element.originX;
  const originalOriginY = element.originY;
  const center = element.getCenterPoint();
  element.set({
    originX: 'center',
    originY: 'center',
    left: center.x,
    top: center.y
  });
  element.rotate(fabricAngle);
  element.setCoords();

  const originPoint = element.translateToOriginPoint(
    element.getCenterPoint(),
    originalOriginX,
    originalOriginY
  );
  element.set({
    originX: originalOriginX,
    originY: originalOriginY,
    left: originPoint.x,
    top: originPoint.y
  });
  canvas.renderAll();
  dispatch(toggleDirtyBit());

  dispatch({
    type: actionTypes.UPDATE_ROTATE_MODAL,
    payload: {
      value: parseFloat(angle)
    }
  });
  dispatch(updatePlacingCoords(element));
  dispatch(generatePreviewOfStickers());
};

export const handleInputRotateModal = (angle, element, canvas) => dispatch => {
  const fabricAngle = angle ? 360 - angle : angle;
  dispatch(rotateElement(element, fabricAngle, canvas));
};

export const dragModal = (e, position) => (dispatch, getState) => {
  const {
    orgWindowWidth,
    orgWindowHeight
  } = getState().fabricCanvas.dimensions;
  let { x, y } = position;
  if (x && y) {
    if (x < 0) {
      if (orgWindowWidth / 2 + 392 < Math.abs(x)) {
        x = -(orgWindowWidth / 2 + 392);
      }
    } else if (orgWindowWidth / 2 < Math.abs(x)) {
      x = orgWindowWidth / 2;
    }

    if (y < 0) {
      if (orgWindowHeight / 2 < Math.abs(y)) {
        y = -(orgWindowHeight / 2);
      }
    } else if (orgWindowHeight / 2 < Math.abs(y)) {
      y = orgWindowHeight / 2;
    }
  }
  dispatch({
    type: actionTypes.UPDATE_DRAGGING_MODAL,
    payload: {
      value: {
        x,
        y
      }
    }
  });
};

// Align elements

export const alignElement = (toolAction, canvas) => (dispatch, getState) => {
  const undoManager = getState().fabricCanvas.undoInstance;
  undoManager.beginGroup();

  const activeObject = canvas.getActiveObject();
  const activeSelectionBackupArray = [];
  if (activeObject.type === 'activeSelection') {
    activeObject.forEachObject(ele => {
      activeSelectionBackupArray.push(ele);
    });
  } else {
    activeSelectionBackupArray.push(activeObject);
  }

  activeSelectionBackupArray.forEach(ele => {
    if (activeObject.type === 'activeSelection') {
      activeObject.removeWithUpdate(ele);
    }
  });

  activeSelectionBackupArray.forEach(ele => {
    const minX = getMinXPointOfObject(ele);
    const maxX = getMaxXPointOfObject(ele);
    const maxY = getMaxYPointOfObject(ele);
    const minY = getMinYPointOfObject(ele);
    const rotatedWidth = maxX - minX;
    const rotatedHeight = maxY - minY;

    let newLeft = ele.left;
    let newTop = ele.top;
    const currentLeft = ele.left;
    const currentTop = ele.top;

    if (toolAction === 'align-left') {
      newLeft = ele.left - minX;
    } else if (toolAction === 'align-center') {
      newLeft = ele.left - minX + (canvas.width - rotatedWidth) / 2;
    } else if (toolAction === 'align-right') {
      newLeft = ele.left + (canvas.width - maxX);
    } else if (toolAction === 'align-top') {
      newTop = ele.top - minY;
    } else if (toolAction === 'align-middle') {
      newTop = ele.top - minY + (canvas.height - rotatedHeight) / 2;
    } else if (toolAction === 'align-bottom') {
      newTop = ele.top + (canvas.height - maxY);
    }

    dispatch(
      addToUndoManager({
        undo: () => {
          dispatch(setPositionForElement(ele, canvas, currentLeft, currentTop));
        },
        redo: () => {
          dispatch(setPositionForElement(ele, canvas, newLeft, newTop));
        }
      })
    );
    ele.set({
      left: newLeft,
      top: newTop
    });
    ele.setCoords();
  });

  activeSelectionBackupArray.forEach(ele => {
    if (activeObject.type === 'activeSelection') {
      activeObject.addWithUpdate(ele);
    }
  });
  undoManager.endGroup();
  canvas.requestRenderAll();
};

export const canvasReset = () => (dispatch, getState) => {
  const { undoInstance, wallCanvas } = getState().fabricCanvas;
  let isGrouped = false;
  wallCanvas.forEachObject(object => {
    if (!isBackground(object) && !isWallLayout(object)) {
      if (!isGrouped) {
        isGrouped = true;
        undoInstance.beginGroup();
      }
      dispatch(deleteAction(object));
    } else {
      dispatch({
        type: actionTypes.SET_ACTIVE_OBJECT,
        payload: {
          activeObject: object
        }
      });
    }
  });
  if (isGrouped) {
    undoInstance.endGroup();
  }

  wallCanvas.renderAll();
};

export const setSelectedTool = tool => dispatch => {
  dispatch({
    type: actionTypes.SET_SELECTED_TOOL,
    payload: {
      selectedTool: tool
    }
  });
};

export const scaleCanvas = (scale, element, canvas) => dispatch => {
  dispatch(changeScale(element, false));
  dispatch(scaleScene(scale, element, canvas, false));
};

export const groupScaleCanvas = (scale, element, canvas) => dispatch => {
  dispatch(changeScale(element, true));
  dispatch(scaleScene(scale, element, canvas, true));
};

export const changeScale = (activeObject, groupScaleState) => (
  dispatch,
  getState
) => {
  const canvas = dispatch(getActiveCanvas(activeObject.placing));
  const undoManager = getState().fabricCanvas.undoInstance;
  if (undoManager.getUndoEnableState() === true) {
    undoManager.beginGroup();

    if (isImageBasedBackground(activeObject)) {
      const prevScaleSliderValue = activeObject.scaleSliderValue;
      dispatch(
        addToUndoManager({
          undo: () => {
            dispatch(
              scaleScene(
                prevScaleSliderValue,
                activeObject,
                canvas,
                groupScaleState
              )
            );
          },
          redo: () => {}
        })
      );
    }
    undoManager.disableUndo();
  }
};

export const endScale = (activeObject, groupScaleState) => (
  dispatch,
  getState
) => {
  const canvas = dispatch(getActiveCanvas(activeObject.placing));
  const undoManager = getState().fabricCanvas.undoInstance;

  if (undoManager.getUndoEnableState() === false) {
    undoManager.enableUndo();

    if (isImageBasedBackground(activeObject)) {
      const { scaleSliderValue } = activeObject;
      dispatch(
        addToUndoManager({
          undo: () => {},
          redo: () => {
            dispatch(
              scaleScene(
                scaleSliderValue,
                activeObject,
                canvas,
                groupScaleState
              )
            );
          }
        })
      );
    }
    undoManager.endGroup();
  }
};

export const scaleScene = (
  inScale,
  element,
  canvas,
  isGroupScale
) => dispatch => {
  const scale = parseFloat(inScale).toFixed(2);
  let oldScaleValue = 1;
  let newScaleValue = 1;
  if (
    (scale >= SLIDER_MIN_VALUE && scale <= SLIDER_MAX_VALUE) ||
    (Object.prototype.hasOwnProperty.call(canvas, 'identifier') &&
      canvas.identifier === 'magnifierCanvas')
  ) {
    if (isImageBasedBackground(element)) {
      if (element.placing.tiled) {
        oldScaleValue = element.tiledDimensions.scale;
        dispatch(scaleTiledScene(scale, element, canvas));
        newScaleValue = element.tiledDimensions.scale;
      } else {
        const sliderCalculatedValue =
          MINIMUM_ZOOM_VALUE +
          (scale * (MAXIMUM_ZOOM_VALUE - SLIDER_MIN_VALUE)) / SLIDER_MAX_VALUE;

        const originalViewScale = dispatch(
          getScaleToFillCanvasFactorForScene(element)
        );
        oldScaleValue = element.scaleX / originalViewScale;
        element.scale(originalViewScale * sliderCalculatedValue).setCoords();
        newScaleValue = sliderCalculatedValue;
      }

      const sceneScaleRatio = newScaleValue / oldScaleValue;
      element.left *= sceneScaleRatio;
      element.top *= sceneScaleRatio;
      element.scaleSliderValue = scale;

      if (isGroupScale) {
        const elementScaleRatio = newScaleValue / oldScaleValue;
        const onlyElements = canvasElementsExceptBackground(canvas);
        onlyElements.forEach(ele => {
          const newScaleX = elementScaleRatio * ele.scaleX;
          ele.scale(newScaleX).setCoords();
          ele.left *= elementScaleRatio;
          ele.top *= elementScaleRatio;
          ele.setCoords();
        });
      }

      const { newX, newY } = dispatch(sceneBoundaryPoints(element));
      element.set({
        left: newX,
        top: newY
      });
      element.setCoords();
      dispatch({
        type: actionTypes.UPDATE_SCALAR_MODAL,
        payload: {
          value: scale
        }
      });
      dispatch(toggleDirtyBit());
      dispatch(checkObjectForPixelation(element));
      canvas.renderAll();
    }
  }
};

export const dragScalarModal = e => dispatch => {
  const { scaleSliderValue } = e;
  dispatch({
    type: actionTypes.UPDATE_SCALAR_MODAL,
    payload: {
      value: scaleSliderValue
    }
  });
};

const scaleTiledScene = (scale, element, canvas) => (dispatch, getState) => {
  const { projectWidth, projectHeight } = getState().home;

  const tileRect = element;
  if (tileRect !== null) {
    const tileWidth = tileRect.tiledDimensions.width;
    const tileHeight = tileRect.tiledDimensions.height;
    const extendedBufferSize = 0;
    const value = Math.max(
      (projectWidth + extendedBufferSize) / tileWidth,
      (projectHeight + extendedBufferSize) / tileHeight
    );

    const maximumTileScale = SLIDER_MAX_VALUE / Math.max(tileWidth, tileHeight);
    const maximumZoom = Math.min(maximumTileScale, value);
    const sliderCalculatedValue =
      MINIMUM_ZOOM_VALUE +
      (scale * (maximumZoom - SLIDER_MIN_VALUE)) / SLIDER_MAX_VALUE;
    element.scaleSliderValue = scale;
    tileRect.tiledDimensions.scale = sliderCalculatedValue;

    dispatch(
      drawTiledImages(
        element,
        tileRect,
        tileRect.tiledDimensions,
        sliderCalculatedValue,
        canvas,
        null
      )
    );
  }
};

export const unlockObject = element => (dispatch, getState) => {
  const { undoInstance } = getState().fabricCanvas;
  const canvas = dispatch(getActiveCanvas(element.placing));
  undoInstance.add({
    undo: () => {
      dispatch(changeLockState(element, canvas, true));
    },
    redo: () => {
      dispatch(changeLockState(element, canvas, false));
    }
  });
  dispatch(changeLockState(element, canvas, false));
};

export const lockObject = element => (dispatch, getState) => {
  const { undoInstance } = getState().fabricCanvas;
  const canvas = dispatch(getActiveCanvas(element.placing));

  undoInstance.add({
    undo: () => {
      dispatch(changeLockState(element, canvas, false));
    },
    redo: () => {
      dispatch(changeLockState(element, canvas, true));
    }
  });
  dispatch(changeLockState(element, canvas, true));
};

export const changeLockState = (element, canvas, lockState) => dispatch => {
  element.placing.locked = lockState;
  dispatch(checkForElementsControls());
  canvas.renderAll();
  dispatch(toggleDirtyBit());
  if (element.placing.placeableType == PROJECT_KEY) {
    dispatch(redrawCanvas());
  }
};

export const setFilteredTools = tools => dispatch => {
  dispatch({
    type: actionTypes.SET_FILTERED_TOOLS,
    payload: {
      filteredTools: tools
    }
  });
};

export const dragToolbar = (e, position) => (dispatch, getState) => {
  const {
    orgWindowWidth,
    orgWindowHeight
  } = getState().fabricCanvas.dimensions;
  let { x, y } = position;
  if (x && y) {
    if (x < 0) {
      if (orgWindowWidth / 2 + 392 < Math.abs(x)) {
        x = -(orgWindowWidth / 2 + 392);
      }
    } else if (orgWindowWidth < Math.abs(x)) {
      x = orgWindowWidth;
    }

    if (y < 0) {
      if (orgWindowHeight < Math.abs(y)) {
        y = -(orgWindowHeight / 2);
      }
    } else if (orgWindowHeight / 2 < Math.abs(y)) {
      y = orgWindowHeight / 2;
    }
  }

  dispatch({
    type: actionTypes.UPDATE_TOOL_DRAG_MODAL,
    payload: {
      value: {
        x,
        y
      }
    }
  });
};
